<template>
  <el-dialog :visible.sync="dialogVisible" width="980px" :show-close="false">
    <video v-bind="$attrs" class="video"></video>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showVideo: false,
    };
  },

  computed: {
    dialogVisible: {
      get({ visible }) {
        return visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
};
</script>

<style lang="sass" scoped>
@import "~@/styles/common.scss"

.el-dialog__wrapper
/deep/ .el-dialog__header
  padding: 0
/deep/ .el-dialog__body
  padding: 0
  height: 550px
  background: #000
.video
  width: 100%
  height: 100%
</style>